export default "/images/vendor/quill/icons/strike.svg?248ad333a3ad0b651e533dfadb12dde0";